/* eslint-disable */
// Constants defined inline to avoid ES6 imports
var USER_ATTR_DEFAULT_PUBLISH_NOW =
  /* @ts-expect-error Apr-17-2025, 11:0UTC FixMe: Complete Migration to TypeScript  */
  'social:defaultPublishNow:' + window.quickFetch.getPortalId();
var USER_ATTR_DEFAULT_PUBLISHING_VIEW = 'social:defaultPublishingView';

// Define endpoints for preferences APIs
var FrontendPreferencesEndpoints = {
  HUBS_SETTING: '/hubs-settings/v2/hubs-setting/fetch',
  USER_ATTRIBUTES: '/user-attributes/v1/app-preferences/user-attributes/fetch',
  HUB_USER_ATTRIBUTES: '/user-attributes/v1/app-preferences/fetch',
};

function earlyRequestPreferencesBatch(
  /* @ts-expect-error Apr-17-2025, 11:0UTC FixMe: Complete Migration to TypeScript  */
  preferenceNames,
  /* @ts-expect-error Apr-17-2025, 11:0UTC FixMe: Complete Migration to TypeScript  */
  earlyRequestKey,
  /* @ts-expect-error Apr-17-2025, 11:0UTC FixMe: Complete Migration to TypeScript  */
  backendEndpoint
) {
  var requestData = { names: preferenceNames };
  /* @ts-expect-error Apr-17-2025, 11:0UTC FixMe: Complete Migration to TypeScript  */
  return window.quickFetch.makeEarlyRequest(earlyRequestKey, {
    /* @ts-expect-error Apr-17-2025, 11:0UTC FixMe: Complete Migration to TypeScript  */
    url: window.quickFetch.getApiUrl(backendEndpoint, true),
    dataType: 'json',
    contentType: 'application/json',
    type: 'POST',
    data: JSON.stringify(requestData),
  });
}

/* @ts-expect-error Apr-17-2025, 11:0UTC FixMe: Complete Migration to TypeScript  */
function earlyRequestUserAttributes(preferenceNames, earlyRequestKey) {
  return earlyRequestPreferencesBatch(
    preferenceNames,
    earlyRequestKey,
    FrontendPreferencesEndpoints.USER_ATTRIBUTES
  );
}

/* @ts-expect-error Apr-17-2025, 11:0UTC FixMe: Complete Migration to TypeScript  */
function earlyRequestHubsSettings(preferenceNames, earlyRequestKey) {
  return earlyRequestPreferencesBatch(
    preferenceNames,
    earlyRequestKey,
    FrontendPreferencesEndpoints.HUBS_SETTING
  );
}

/* @ts-expect-error Apr-17-2025, 11:0UTC FixMe: Complete Migration to TypeScript  */
function earlyRequestHubUserAttributes(preferenceNames, earlyRequestKey) {
  return earlyRequestPreferencesBatch(
    preferenceNames,
    earlyRequestKey,
    FrontendPreferencesEndpoints.HUB_USER_ATTRIBUTES
  );
}

/* @ts-expect-error Apr-17-2025, 11:0UTC FixMe: Complete Migration to TypeScript  */
function url(endpoint) {
  /* @ts-expect-error Apr-17-2025, 11:0UTC FixMe: Complete Migration to TypeScript  */
  return window.quickFetch.getApiUrl('/' + endpoint);
}

(function () {
  var debugEnabled = false;
  var brandId = null;

  try {
    debugEnabled = Boolean(
      localStorage &&
        localStorage.getItem &&
        localStorage.getItem('SOCIAL_DEBUG')
    );

    const _brandId = JSON.parse(
      localStorage.getItem('SELECTED_BUSINESS_UNIT') || '{}'
    )[window.quickFetch.getPortalId()];
    if (typeof _brandId === 'number') {
      brandId = _brandId;
    }
  } catch (e) {
    console.warn('Unable to access localStorage in quickFetch.js');
  }

  function logDebug() {
    if (debugEnabled) {
      /* @ts-expect-error Apr-17-2025, 11:0UTC FixMe: Complete Migration to TypeScript  */
      console.log.apply(console, arguments);
    }
  }

  window.quickFetch.afterAuth((auth) => {
    const hasSocialBrandsGate =
      auth.portal.enabled_v3_gates.includes('Social:Brands');

    const hasBUScope = auth.user.scopes.includes('business-units-access');
    const hasBrandId = hasSocialBrandsGate && hasBUScope && brandId !== null;

    /* @ts-expect-error Apr-17-2025, 11:0UTC FixMe: Complete Migration to TypeScript  */
    window.quickFetch.makeEarlyRequest('accounts-with-channels', {
      url: url(
        'broadcast/v2/accounts/with-channels?allChannels=true' +
          (hasBrandId ? '&brandId=' + brandId : '')
      ),
      dataType: 'json',
    });
  });

  /* @ts-expect-error Apr-17-2025, 11:0UTC FixMe: Complete Migration to TypeScript  */
  window.quickFetch.makeEarlyRequest('data-privacy-settings', {
    url: url('data-privacy-settings/hub-settings'),
    dataType: 'json',
  });

  // disabling temporarily until we figure out if this is the issue
  // with fetching content-assistance settings
  // window.quickFetch.makeEarlyRequest('content-assistance-settings', {
  //   url: url('content-assistance/v1/settings'),
  //   dataType: 'json',
  // });

  earlyRequestUserAttributes(
    [USER_ATTR_DEFAULT_PUBLISHING_VIEW],
    'social-ui-user-attributes-early-request'
  );

  earlyRequestHubUserAttributes(
    [USER_ATTR_DEFAULT_PUBLISH_NOW],
    'social-ui-hub-attributes-early-request'
  );

  return;
})();


